// Export types
export type { ConflictType, ConflictResponse, RefetchOptions, MergeOptions, ConflictHandler } from './types';
export { isConflictResponse } from './types';

// Export registry
export { ConflictHandlerRegistry, conflictHandlerRegistry } from './registry';

// Export errors
export { ConflictError, NoConflictHandlerError, MaxRetriesExceededError } from './errors';

// Export logger
export { conflictLogger } from './logger';
export type { ConflictLogEntry, ConflictStats } from './logger';

// Import task handlers (existing)
import { taskConflictHandler } from '../../stores/taskLists/conflictHandlers/taskConflictHandler';
import { taskListUnitConflictHandler } from '../../stores/taskLists/conflictHandlers/taskListUnitConflictHandler';
import { taskReportConflictHandler } from '../../stores/taskLists/conflictHandlers/taskReportConflictHandler';

// Import core entity handlers (new)
import { workspaceConflictHandler } from '../conflictHandlers/core/workspaceConflictHandler';
import { itemConflictHandler } from '../conflictHandlers/core/itemConflictHandler';
import { clientConflictHandler } from '../conflictHandlers/core/clientConflictHandler';
import { clientUserConflictHandler } from '../conflictHandlers/core/clientUserConflictHandler';

// Import quiz entity handlers (new)
import { quizConflictHandler } from '../../stores/quiz/conflictHandlers/quizConflictHandler';
import { quizQuestionConflictHandler } from '../../stores/quiz/conflictHandlers/quizQuestionConflictHandler';
import { quizAnswerConflictHandler } from '../../stores/quiz/conflictHandlers/quizAnswerConflictHandler';

import { conflictHandlerRegistry } from './registry';

/**
 * Register all conflict handlers.
 * Call this during application initialization to enable automatic conflict resolution.
 * 
 */
export function registerConflictHandlers(): void {
    console.log('[Conflict Resolution] Registering conflict handlers...');
    
    // Register task handlers (existing - use 'version' field)
    conflictHandlerRegistry.register(taskConflictHandler);
    conflictHandlerRegistry.register(taskListUnitConflictHandler);
    conflictHandlerRegistry.register(taskReportConflictHandler);
    
    // Register core entity handlers (new - use 'version' field)
    conflictHandlerRegistry.register(workspaceConflictHandler);
    conflictHandlerRegistry.register(itemConflictHandler);
    conflictHandlerRegistry.register(clientConflictHandler);
    conflictHandlerRegistry.register(clientUserConflictHandler);
    
    // Register quiz entity handlers (new - use 'version' field)
    conflictHandlerRegistry.register(quizConflictHandler);
    conflictHandlerRegistry.register(quizQuestionConflictHandler);
    conflictHandlerRegistry.register(quizAnswerConflictHandler);

    const registeredTypes = conflictHandlerRegistry.getRegisteredTypes();
    console.log(`[Conflict Resolution] Registered handlers for: ${registeredTypes.join(', ')}`);
}
